import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./common-view.css";

export default function Success() {
  const { t } = useTranslation();

  return (
    <div
      className="view-page"
      style={{
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center"
      }}
    >
      <div
        className="view-card"
        style={{ maxWidth: "500px", padding: "40px", width: "90%" }}
      >
        <div style={{ fontSize: "64px", marginBottom: "10px" }}>✅</div>

        <h2
          style={{ color: "#0f172a", marginBottom: "15px", fontSize: "24px" }}
        >
          {t("success.title", "Payment Successful!")}
        </h2>

        <p
          style={{
            color: "#64748b",
            marginBottom: "30px",
            fontSize: "16px",
            lineHeight: "1.5"
          }}
        >
          {t(
            "success.message",
            "Thank you for your order. Your payment has been securely processed, and the business has been notified. They will begin preparing your order shortly."
          )}
        </p>

        <Link
          to="/"
          style={{
            display: "inline-block",
            background: "#2563eb",
            color: "#ffffff",
            padding: "12px 24px",
            borderRadius: "8px",
            fontWeight: "bold",
            textDecoration: "none"
          }}
        >
          {t("success.returnHome", "Return to Home")}
        </Link>
      </div>
    </div>
  );
}